class GaiaTicker extends HTMLElement {
  constructor() {
    super();
    this.isPaused = false;
  }

  connectedCallback() {
    this.refreshAnnouncementBar();
    window.addEventListener("resize", this.refreshAnnouncementBar.bind(this));
    this.setupControls();
    this.applyStoredState();
  }

  disconnectedCallback() {
    window.removeEventListener(
      "resize",
      this.refreshAnnouncementBar.bind(this)
    );
  }

  // Set up ticker
  refreshAnnouncementBar() {
    const ticker = this;
    const sectionWidth = ticker.getBoundingClientRect().width;
    const tickerItems = ticker.querySelector(".ticker-items");
    const tickerWidth = tickerItems.getBoundingClientRect().width;
    const tickerScroller = ticker.querySelector(".ticker-scroller");

    ticker.style.setProperty("--ticker-width", tickerWidth + "px");
    ticker.style.setProperty("--ticker-width-mobile", tickerWidth + "px");
    ticker.style.setProperty("--ticker-move", "-" + tickerWidth + "px");
    ticker.style.setProperty("--ticker-move-mobile", "-" + tickerWidth + "px");

    const tickerCopies = ticker.querySelectorAll(".ticker-duplicates");
    tickerCopies.forEach((tickerCopy) => {
      tickerCopy.remove();
    });

    for (
      let w = tickerWidth;
      w < sectionWidth + tickerWidth;
      w += tickerWidth
    ) {
      const tickerCopy = tickerItems.cloneNode(true);
      tickerCopy.classList.add("ticker-duplicates");
      tickerCopy.setAttribute("aria-hidden", true);
      tickerScroller.appendChild(tickerCopy);
    }

    tickerScroller.style.opacity = "1";
  }

  // Controls for ticker accessibility
  setupControls() {
    const ticker = this;
    const pauseButton = ticker.querySelector(".pause-ticker");
    const playButton = ticker.querySelector(".play-ticker");
    // const closeButton = ticker.querySelector(".close-ticker");
    const announcementBar = ticker.closest(".section--announcement-bar");
    const tickerScroller = ticker.querySelector(".ticker-scroller");
    // const debugResetButton = ticker.querySelector(".debug-reset");

    // Pause ticker
    pauseButton.addEventListener("click", () => {
      ticker.isPaused = true;
      tickerScroller.style.animationPlayState = "paused";
      pauseButton.style.display = "none";
      playButton.style.display = "flex";
      sessionStorage.setItem("tickerState", "paused");
      pauseButton.querySelector("button").setAttribute("aria-hidden", "true");
      playButton.querySelector("button").removeAttribute("aria-hidden");
      playButton.querySelector("button").focus();
    });

    // Play ticker
    playButton.addEventListener("click", () => {
      ticker.isPaused = false;
      tickerScroller.style.animationPlayState = "running";
      playButton.style.display = "none";
      pauseButton.style.display = "flex";
      sessionStorage.setItem("tickerState", "running");
      pauseButton.querySelector("button").removeAttribute("aria-hidden");
      playButton.querySelector("button").setAttribute("aria-hidden", "true");
      pauseButton.querySelector("button").focus();
    });

    // Close ticker
    // closeButton.addEventListener("click", () => {
    //   announcementBar.style.display = "none";
    //   sessionStorage.setItem("tickerState", "closed");
    // });

    // Debug reset cookies
    // debugResetButton.addEventListener("click", () => {
    //   sessionStorage.removeItem("tickerState");
    //   location.reload();
    // });
    if (playButton.style.display === "flex") {
      playButton.removeAttribute("aria-hidden");
    }
  }

  // Get stored ticker state and apply it
  applyStoredState() {
    const ticker = this;
    const pauseButton = ticker.querySelector(".pause-ticker");
    const playButton = ticker.querySelector(".play-ticker");
    const announcementBar = ticker.closest(".section--announcement-bar");
    const tickerScroller = ticker.querySelector(".ticker-scroller");

    const storedState = sessionStorage.getItem("tickerState");

    if (storedState === "paused") {
      ticker.isPaused = true;
      tickerScroller.style.animationPlayState = "paused";
      pauseButton.style.display = "none";
      playButton.style.display = "flex";
      pauseButton.querySelector("button").setAttribute("aria-hidden", "true");
      playButton.querySelector("button").removeAttribute("aria-hidden");
    } else if (storedState === "running") {
      ticker.isPaused = false;
      tickerScroller.style.animationPlayState = "running";
      playButton.style.display = "none";
      pauseButton.style.display = "flex";
      playButton.querySelector("button").setAttribute("aria-hidden", "true");
      pauseButton.querySelector("button").removeAttribute("aria-hidden");
    } else if (storedState === "closed") {
      announcementBar.style.display = "none";
    } else {
      ticker.isPaused = false;
      tickerScroller.style.animationPlayState = "running";
      playButton.style.display = "none";
      pauseButton.style.display = "flex";
      playButton.querySelector("button").setAttribute("aria-hidden", "true");
      pauseButton.querySelector("button").removeAttribute("aria-hidden");
    }

    if (playButton.style.display === "flex") {
      playButton.removeAttribute("aria-hidden");
    }
  }
}

customElements.define("gaia-ticker", GaiaTicker);
